import { render } from "./App.vue?vue&type=template&id=0d738e30"
const script = {}

import exportComponent from "C:\\Users\\L14D0P0PC06\\Desktop\\pokedex\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__